// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"561":"920eccf5","565":"e3071620","702":"b10d0397","784":"895ea515","862":"4afd6b20","998":"0f988c59"}[chunkId] + ".chunk.css";
};